import { render, staticRenderFns } from "./SignupCard.vue?vue&type=template&id=0f4b6eed&"
import script from "./SignupCard.vue?vue&type=script&lang=js&"
export * from "./SignupCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports